// Core
import React, { Component } from 'react';
import ProgressRing from 'components/ProgressRing';

// Styles
import './index.scss';

const TimeSaved = (timeSaved, totalConversations) => {
  const promoCounter = makePromotionalCounter(timeSaved);
  return (
    <div className="TimeSaved BotStats-metricSingle">
      <div className="ringContainer">
        <div className="TimeSaved-timerbg">
          <i className="fal fa-stopwatch"></i>

          <div className="TimeSaved-promoCounter">
            <div className="TimeSaved-promoValue">{promoCounter.value}</div>
            <div className="TimeSaved-promoLabel">{promoCounter.label}</div>
          </div>
        </div>
      </div>

      <div className="BotStats-metricSingleDetails">
        <div className="BotStats-metricSingleTitle">Time Saved</div>
        <div className="BotStats-metricSingleBody">
          The bot spent an average (mean) of{' '}
          {makeAverage(timeSaved, totalConversations)} per conversation across{' '}
          {totalConversations} conversations.
        </div>
      </div>
    </div>
  );
};

export const makeAverage = (timeSaved, totalConversations) => {
  if (timeSaved === 0 || totalConversations === 0) {
    return 0 + ' seconds';
  }

  const secondsPerConversation = timeSaved / totalConversations;

  const minute = 60;
  const hour = 3600;
  const day = 86400;

  if (secondsPerConversation < 1) {
    return 'about 1 second';
  } else if (secondsPerConversation < minute) {
    return (
      Math.floor(secondsPerConversation) +
      ' second' +
      pluralize(secondsPerConversation)
    );
  } else if (secondsPerConversation < hour) {
    const duration = Math.floor(secondsPerConversation / minute);
    return duration + ' minute' + pluralize(duration);
  } else if (secondsPerConversation < day) {
    const duration = Math.floor(secondsPerConversation / hour);
    return duration + ' hour' + pluralize(duration);
  } else {
    const duration = Math.floor(secondsPerConversation / day);
    return duration + ' day' + pluralize(duration);
  }
};

const pluralize = (value) => (value === 1 ? '' : 's');

export const makePromotionalCounter = (timeSaved) => {
  if (!timeSaved || timeSaved === 0) {
    return { value: 0, label: 'minutes' };
  }

  const minute = 60;
  const hour = 3600;
  const nineNineNineHours = 3596400;
  const day = 86400;

  if (timeSaved < minute) {
    return { value: timeSaved, label: 'second' + pluralize(timeSaved) };
  } else if (timeSaved < hour) {
    const duration = Math.floor(timeSaved / minute);
    return { value: duration, label: 'minute' + pluralize(duration) };
  } else if (timeSaved >= hour && timeSaved <= nineNineNineHours) {
    const duration = Math.floor(timeSaved / hour);
    return { value: duration, label: 'hour' + pluralize(duration) };
  } else {
    const duration = Math.floor(timeSaved / day);
    return { value: duration, label: 'day' + pluralize(duration) };
  }

  return timeSaved;
};

export default TimeSaved;
